import { JamfComplianceBenchmarkDto } from '@ampsec/platform-client';
import { Typography } from 'Components/atoms';
import RoleDropdown from 'Components/pages/SettingsPage/RoleDropdown';
import { JAMF_COMPLIANCE_BENCHMARK_TITLE, STATUS, STATUS_OPTIONS } from 'Core-utils/constants/constants';
import { TableColumn } from 'react-data-table-component';
import './styles.scss';
import { Status } from 'Core-utils/helpers/helpers';

export const COMPLIANCE_BENCHMARKS_CONFIG_COLUMNS = (
    handleUpdateStatus: (row: JamfComplianceBenchmarkDto, status: Status) => void,
): TableColumn<JamfComplianceBenchmarkDto>[] => [
    {
        id: 'benchmarkTitle',
        name: <Typography variant="body2">{JAMF_COMPLIANCE_BENCHMARK_TITLE}</Typography>,
        cell: (row: JamfComplianceBenchmarkDto) => (
            <div className={`findings-config__name opacity-1}`}>
                <Typography variant="body5">{row.title}</Typography>
            </div>
        ),
        style: {
            cursor: 'pointer',
        },
    },
    {
        id: 'status',
        name: <Typography variant="body2">{STATUS}</Typography>,
        cell: (row: JamfComplianceBenchmarkDto) => {
            const handleDropdownChange = (eventKey: string | null, _e: any) => {
                handleUpdateStatus(row, eventKey as Status);
            };
            return (
                <div className={'opacity-1'}>
                    <RoleDropdown dropDownItems={STATUS_OPTIONS} value={row.status!} onChange={handleDropdownChange} />
                </div>
            );
        },
        sortable: true,
        sortFunction: (rowA: JamfComplianceBenchmarkDto, rowB: JamfComplianceBenchmarkDto) => {
            if (rowA.status === rowB.status) {
                return 0;
            }
            if (rowA.status === Status.ENABLED) {
                return -1;
            }
            if (rowB.status === Status.ENABLED) {
                return 1;
            }
            if (rowA.status === Status.DISABLED) {
                return -1;
            }
            if (rowB.status === Status.DISABLED) {
                return 1;
            }
            return 0;
        },
        width: '20rem',
    },
];
